<template>
  <div class="map-legend">
    
    <div class="legend-item">
      <span class="legend-label">Shared Churches</span>
      <img src="circle.png" alt="Circle Icon" class="legend-icon" />
    </div>

    <div class="legend-item">
      <span class="legend-label">New Churches #1</span>
      <img src="triangle.png" alt="Triangle Icon" class="legend-icon" />
    </div>
    

    <div class="legend-item">
      <span class="legend-label">New Churches #2</span>
      <img src="square.png" alt="Square Icon" class="legend-icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapLegend',
};
</script>

<style scoped>
.map-legend {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: rgba(255, 255, 255, 0.8); /* Transparent white background */
  border: 1px solid #ccc; /* Light border */
  padding: 10px;
  border-radius: 8px;
  display: flex;
  flex-direction: column; /* Stack the items vertically */
  align-items: center; /* Center the items */
}

.legend-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px; /* Space between each legend item */
}

.legend-label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px; /* Space between label and icon */
}

.legend-icon {
  width: 30px; /* Adjust size as needed */
  height: 30px;
}
</style>
